import React, { useEffect } from 'react';
import { Formik } from 'formik';
import FormInput from '../../../general/form-input/form-input.component';
import Button from '../../../general/button/button.component';
import './personaldetails.student.styles.scss';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Padding from '../../../general/padding/Padding';
import { useNavigate } from 'react-router-dom';
import db from '../../../../firebase.config';
import { doc, setDoc } from "firebase/firestore"; 
import { globalUSN, globalPassword } from "../../general/sign-up/sign-up.component";
import ProgressIndicator from '../../general/progress-indicator/progress-indicator.component';
import { Backdrop, CircularProgress } from '@mui/material';

const PersonalDetails = () => {

    let navigate = useNavigate();
    useEffect(() => {
      console.log(globalUSN);
      if(!globalUSN)
        navigate('../../../sessionexpired')
    })
    

  return (
  <div>
    <Formik
      initialValues={{ fullname: '', phone: '', stream: '', section: '', semester: '', email: ''}}
      validate={values => {
        const errors = {};
        if (!values.fullname) {
          errors.fullname = 'Required';
        }
        if (!values.phone) {
          errors.phone = 'Required';
        }
        if (!values.stream) {
          errors.stream = 'Required';
        }
        if (!values.section) {
          errors.section = 'Required';
        }
        if (!values.semester) {
          errors.semester = 'Required';
        }
        if (!values.email) {
          errors.email = 'Required';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting, isSubmitting }) => {
      setSubmitting(true)
      console.log(isSubmitting)
      const data = JSON.parse(JSON.stringify(values, null, 2));
      console.log(data);
      try {
      const studentRef = doc(db, 'studentData', globalUSN);
      console.log(studentRef);
      setDoc(studentRef, data , { merge: true });
      }
      catch (err)
      {
        console.log(err);
      }
      setSubmitting(true);
      setTimeout(() => {navigate(`../three`);},3000)

}}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => (
        
        <form onSubmit={handleSubmit}>
        <ProgressIndicator />
        <span className="personal-details" style={{marginBottom:'3%'}}>
        <Typography variant="h4" sx={{fontFamily:'Montserrat'}}>Personal Details</Typography>
          <FormInput 
            placeholder="Full Name"
            type="text"
            name="fullname"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.fullname}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.fullname && errors.fullname}</span>
          <FormInput
            placeholder="Phone"
            type="text"
            name="phone"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.phone}
          />
           <span style={{fontFamily : 'Montserrat'}}>{touched.phone && errors.phone}</span>
           <FormInput
            placeholder="Stream"
            type="text"
            name="stream"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.stream}
          />
           <span style={{fontFamily : 'Montserrat'}}>{touched.stream && errors.stream}</span>
          </span>
          
          <span className="personal-details" style={{marginBottom:'1px'}}>
          <Padding/>
          <Padding/>
          <FormInput
            placeholder="Section"
            type="text"
            name="section"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.section}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.section && errors.section}</span>
          <FormInput
            placeholder="Semester"
            type="text"
            name="semester"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.semester}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.semester && errors.semester}</span>
          <FormInput
            placeholder="Email address"
            type="email"
            name="email"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.email && errors.email}</span>
          </span>
          <span className="personal-details">
          <Button type="submit" disabled={isSubmitting}>
            Next
          </Button>
          <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isSubmitting}
          >
          <CircularProgress color="inherit" />
          </Backdrop>
          </span>
        </form>
      )}
    </Formik>
  </div>
  );
}

export default PersonalDetails;

